import React, { useEffect, useState } from 'react'
import Select from "react-select";
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { debugLogPages } from '../../app/helpers/debugHelper';
import TableVerticalAssistance from './TableVerticalAssistance';
import { startRegisterCompareResult } from '../../app/actions/compareResultActions';

const ComparisonContainerAssistanceByField = () => {

  debugLogPages(':: ComparisonContainerAssistanceByField');

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { assistancesS } = useSelector((state) => state.assistance);

  const { listFieldsAssistance } = useSelector((state) => state.moduleConfig);
  const { comparisonAssistanceComboEnabled } = useSelector((state) => state.configuration);
  const [listFieldsToCompare, setListFieldsToCompare] = useState();
  const [selectedField, setSelectedField] = useState()

  useEffect(() => {
    let listFieldsToCompareT = [];
    listFieldsAssistance.forEach(element => {
      
      if (element.is_comparable) {
        
        listFieldsToCompareT.push(element);
      }
    });
    setListFieldsToCompare(listFieldsToCompareT);
  }, [])

  const handleChangeSelectCompare = (event) => {

    if (event != null) {
      setSelectedField(event);

      let selectedIds = "";
      let countIds = 0;
      for (let index = 0; index < assistancesS.length; index++) {
        if (assistancesS[index].isSelected) {
          assistancesS[index].isCompared = true;

          if (countIds === 0) {
              selectedIds = selectedIds.concat(assistancesS[index].id);
            } else {
              selectedIds = selectedIds.concat(";", assistancesS[index].id);
            }

            countIds++;

        }else{
          assistancesS[index].isCompared = false;
        }
      }

      const objectCompare = {
        deleted:false,
        compare_ids:selectedIds,
        total_selected:countIds,
        selected_field:event.field,
        is_compare_all_fields:false
      }
      dispatch(startRegisterCompareResult(objectCompare));


    } else {
      setSelectedField(null);
    }
  };


  return (
    <div>

      <div className="flexbox-title">
         <h2>{t("general.compare-assistance")}</h2>
      </div>

      <br />

      {
        comparisonAssistanceComboEnabled === "true" &&
        <div>
          <Select
            myFontSize="14px"
            onChange={(event) => handleChangeSelectCompare(event)}
            className={`basic-single form-control`}
            classNamePrefix="select"
            name="texto"
            options={listFieldsToCompare}
            getOptionLabel={(option) => t(`${option.module_text}.synthetic.${option.field}`)}
            getOptionValue={(option) => `${option}`}
            isClearable={true}
            isSearchable={true}
            placeholder="Seleccione un Campo para comparar"
          />

          {selectedField && selectedField.field &&
            (<TableVerticalAssistance selectedField={selectedField} data={assistancesS} />)
          }

        </div>
      }

      <br />

    </div>
  )
}

export default ComparisonContainerAssistanceByField